import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const Login10 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template10');
    };

    const inputClass = "w-full px-0 py-3.5 bg-transparent text-[#1C1917] text-sm font-light placeholder-[#A8A29E] focus:outline-none transition-colors duration-300";

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px] min-h-[80vh] flex items-center justify-center px-5 md:px-8">
                    <div className="w-full max-w-sm py-12 md:py-20">
                        {/* Header */}
                        <div className="text-center mb-10">
                            <h1 className="text-2xl md:text-3xl font-light text-[#1C1917] tracking-tight mb-2">
                                Welcome Back
                            </h1>
                            <p className="text-[#A8A29E] text-xs font-light">
                                Sign in to your account
                            </p>
                        </div>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            <div style={{ borderBottom: '1px solid #E7E5E4' }}>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    className={inputClass}
                                    style={{ fontFamily: "'Inter', sans-serif" }}
                                    required
                                />
                            </div>

                            <div className="relative" style={{ borderBottom: '1px solid #E7E5E4' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    className={inputClass}
                                    style={{ fontFamily: "'Inter', sans-serif", paddingRight: '40px' }}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-0 top-1/2 -translate-y-1/2 text-[#A8A29E] hover:text-[#78716C] transition-colors bg-transparent border-none cursor-pointer p-2"
                                >
                                    {showPassword
                                        ? <EyeOff className="w-4 h-4" strokeWidth={1.5} />
                                        : <Eye className="w-4 h-4" strokeWidth={1.5} />
                                    }
                                </button>
                            </div>

                            <div className="flex justify-end mt-3 mb-8">
                                <button
                                    type="button"
                                    className="text-[#78716C] text-xs font-light hover:text-[#1C1917] transition-colors bg-transparent border-none cursor-pointer p-0"
                                >
                                    Forgot password?
                                </button>
                            </div>

                            <button
                                type="submit"
                                className="w-full py-3.5 bg-[#78716C] text-white text-xs tracking-[2px] uppercase font-normal hover:bg-[#57534E] transition-colors duration-300 cursor-pointer border-none"
                            >
                                Sign In
                            </button>
                        </form>

                        {/* Sign Up Link */}
                        <div className="text-center mt-8">
                            <p className="text-[#A8A29E] text-xs font-light">
                                New here?{' '}
                                <span
                                    onClick={() => navigate('/template10/signup')}
                                    className="text-[#78716C] hover:text-[#1C1917] cursor-pointer transition-colors underline underline-offset-4"
                                >
                                    Create an account
                                </span>
                            </p>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Login10;
